var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 12,
    viewBox: "0 0 23 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 6.25C0.25 3.15625 2.74609 0.625 5.875 0.625H9.53125C9.98828 0.625 10.375 1.01172 10.375 1.46875C10.375 1.96094 9.98828 2.3125 9.53125 2.3125H5.875C3.69531 2.3125 1.9375 4.10547 1.9375 6.25C1.9375 8.42969 3.69531 10.1875 5.875 10.1875H9.53125C9.98828 10.1875 10.375 10.5742 10.375 11.0312C10.375 11.5234 9.98828 11.875 9.53125 11.875H5.875C2.74609 11.875 0.25 9.37891 0.25 6.25ZM17.125 11.875H13.4688C12.9766 11.875 12.625 11.5234 12.625 11.0312C12.625 10.5742 12.9766 10.1875 13.4688 10.1875H17.125C19.2695 10.1875 21.0625 8.42969 21.0625 6.25C21.0625 4.10547 19.2695 2.3125 17.125 2.3125H13.4688C12.9766 2.3125 12.625 1.96094 12.625 1.46875C12.625 1.01172 12.9766 0.625 13.4688 0.625H17.125C20.2188 0.625 22.75 3.15625 22.75 6.25C22.75 9.37891 20.2188 11.875 17.125 11.875ZM15.1562 5.40625C15.6133 5.40625 16 5.79297 16 6.25C16 6.74219 15.6133 7.09375 15.1562 7.09375H7.84375C7.35156 7.09375 7 6.74219 7 6.25C7 5.79297 7.35156 5.40625 7.84375 5.40625H15.1562Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d707224b.svg";
export { ForwardRef as ReactComponent };